export default __webpack_public_path__ + "static/media/offset_logo_picture_gold.ab7229ab.svg";